// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__A1B3x","messages":"Chat_messages__1P9kv","dateDivider":"Chat_dateDivider__2cOOL"};